import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const parsePreciseDate = (dateString) => {
    
    const parts = dateString.split(".");
    const baseTime = new Date(parts[0]).getTime()
    if (parts.length > 1) {
      
        const fractionalMatch = parts[1].match(/^\d+/);
        if (fractionalMatch) {
            const fractionalPart = fractionalMatch[0];
            
            const additionalMs = Number("0." + fractionalPart) * 1000;
            return baseTime + additionalMs;
        }
    }
    return baseTime;
};

const HistoricosComponent = ({ formattedDetails }) => {
    // Cria uma cópia do array e ordena os itens que são objetos (com propriedade "data")
    const sortedHistoricos = [...formattedDetails.historicos].sort((a, b) => {
        // Se ambos forem objetos com a propriedade "data", utiliza a função auxiliar para ordenar
        if (typeof a === "object" && typeof b === "object" && a.data && b.data) {
            return parsePreciseDate(b.data) - parsePreciseDate(a.data); // data mais nova primeiro
        }
        // Se não forem objetos, mantém a ordem original
        return 0;
    });

    return (
        <div className="flex justify-between">
            <ul className="list-disc custom-list pl-5 flex-1">
                {sortedHistoricos.map((item, index) => {
                    // Se o item for uma string, exibe-o diretamente
                    if (typeof item === "string") {
                        return <li key={index}>{item}</li>;
                    }
                    // Caso seja um objeto, exibe seus detalhes
                    return (
                        <div key={index} className="min-w-0 break-words mb-6 shadow-lg rounded-lg bg-white p-6">
                            <p>
                                <strong>Funcionário:</strong> {item.funcionario}
                            </p>
                            <p>
                                <strong>Cargo:</strong> {item.cargo}
                            </p>
                            <p>
                                <strong>Status:</strong> {item.sts}
                            </p>
                            <p>
                                <strong>Data:</strong> {new Date(item.data).toLocaleString()}
                            </p>
                            <div className="flex justify-between">
                                <p>
                                    <strong>Base:</strong> {item.base.nome}
                                </p>
                                <div className="text-right font-bold ">

                                    {item.descricao}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </ul>
        </div>
    );
};

const HistoricosDialog = ({ formattedDetails }) => {
    const [displayDialog, setDisplayDialog] = useState(false);

    const openDialog = () => {
        setDisplayDialog(true);
    };

    const closeDialog = () => {
        setDisplayDialog(false);
    };

    return (
        <div>
            <Button
                label="Históricos"
                icon="pi pi-eye"
                onClick={openDialog}
                className="bg-purple-500 mx-4 text-white px-3 py-1 rounded-md shadow  hover:bg-lightBlue-500 font-bold"
            />

            <Dialog
                header="Históricos"
                visible={displayDialog}
                style={{ width: "50vw" }}
                onHide={closeDialog}
            >
                <HistoricosComponent formattedDetails={formattedDetails} />
            </Dialog>
        </div>
    );
};

export default HistoricosDialog;
